import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const ChevronCircleLeft = ({
	size,
	...props
}: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 30C8.28 30 2 23.72 2 16C2 8.28 8.28 2 16 2C23.72 2 30 8.28 30 16C30 23.72 23.72 30 16 30ZM16 4C9.383 4 4 9.383 4 16C4 22.617 9.383 28 16 28C22.617 28 28 22.617 28 16C28 9.383 22.617 4 16 4Z" />
		<path d="M14.281 16L17.781 11.624C17.918 11.453 18.001 11.236 18.001 11C18.001 10.448 17.553 10 17.001 10C16.685 10 16.404 10.147 16.221 10.376L12.221 15.377C12.084 15.548 12.002 15.765 12.002 16.001C12.002 16.237 12.084 16.454 12.221 16.625L16.221 21.626C16.404 21.855 16.686 22.002 17.001 22.002C17.553 22.002 18.001 21.554 18.001 21.002C18.001 20.766 17.919 20.549 17.781 20.378L14.281 16.002V16Z" />
	</svg>
);

export default ChevronCircleLeft;
